export default __webpack_public_path__ + "static/media/tz.d7ad858e.jpg";